import { z } from 'zod';
import {
  AcademicYear,
  AdHocInvoiceId,
  BulkChargeJobId,
  StudentId,
} from '../types/branded';
import { BillingCategorySchema } from '../types/enums';

export const AdHocInvoiceStatusSchema = z.enum([
  'unpaid',
  'partial',
  'paid',
  'overdue',
]);
export type AdHocInvoiceStatus = z.infer<typeof AdHocInvoiceStatusSchema>;

export const AdHocInvoiceSchema = z.object({
  id: AdHocInvoiceId,
  tuitionAccountId: z.string().min(1),
  invoiceNumber: z.string().min(1),
  academicYear: AcademicYear.nullable().optional(),
  chargeName: z.string().min(1).max(100),
  amount: z.number().positive(),
  perStudent: z.boolean(),
  billingCategory: BillingCategorySchema,
  dueDate: z.string().min(1),
  status: AdHocInvoiceStatusSchema,
  isOverdue: z.boolean().default(false),
  amountPaid: z.number().nonnegative().default(0),
  notes: z.string().max(500).nullable().optional(),
  studentId: StudentId.nullable().optional(),
  bulkChargeJobId: BulkChargeJobId.nullable().optional(),
  createdBy: z.string().nullable().optional(),
  schoolId: z.string().min(1),
  createdAt: z.string().min(1),
  updatedAt: z.string().min(1),
});
export type AdHocInvoice = z.infer<typeof AdHocInvoiceSchema>;

export const BulkChargeSegmentStudentSchema = z.object({
  id: StudentId,
  tuitionAccountId: z.string().min(1),
  name: z.string().min(1),
  grade: z.string().nullable(),
  division: z.string().nullable(),
  familyName: z.string().min(1),
  rateCategory: z.string().nullable().optional(),
});
export type BulkChargeSegmentStudent = z.infer<typeof BulkChargeSegmentStudentSchema>;

export const BulkChargeSegmentPreviewSchema = z.object({
  studentCount: z.number().int().nonnegative(),
  familyCount: z.number().int().nonnegative(),
  students: z.array(BulkChargeSegmentStudentSchema).default([]),
});
export type BulkChargeSegmentPreview = z.infer<typeof BulkChargeSegmentPreviewSchema>;
